<template>
  <v-card class="padding-20">
    <v-card-title>Add Household</v-card-title>
    <v-card-text class="padding-10">
      <v-form ref="addHousehold" lazy-validation>
        <v-row>
          <v-col cols="3">
            <v-text-field
              v-model="household.aptNumber"
              type="number"
              label="Apt. No"
              :min="0"
              :rules="requiredRules"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="9">
            <v-text-field
              v-model="household.streetName"
              label="Street Name"
              required
              :rules="requiredRules"
              outlined
              prepend-inner-icon="fas fa-road"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-alert
          v-if="alert.message != ''"
          :type="alert.type"
          :color="alert.type"
          outlined
          >{{ alert.message }}</v-alert
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="addHousehold">Submit</v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { householdsRef } from "../../firebaseApp";
import householdObject from "../json/household.json";

export default {
  props: ["communityKey"],
  data: () => ({
    household: householdObject,
    existingHouseholds: [],
    alert: {
      type: "",
      message: "",
    },
    requiredRules: [(v) => !!v || "Required"],
  }),
  methods: {
    addHousehold() {
      if (this.$refs.addHousehold.validate()) {
        this.household.dateAdded = Date.now();
        this.household.communityKey = this.communityKey;
        if (this.isUnique("aptNumber") || this.isUnique("streetName")) {
          householdsRef.push(this.household).key;
          this.alert.message =
            this.household.aptNumber +
            " " +
            this.household.streetName +
            " has been successfully added";
          this.alert.type = "success";
        } else {
          this.alert.type = "error";
          this.alert.message =
            "A household has already been registered under the same address. Please use a different one";
          this.community.name = "";
        }
      }
    },
    isUnique(prop) {
      let value = this.household[prop];
      let isUnique = true;
      this.existingHouseholds.forEach((item) => {
        if (value == item.val()[prop]) {
          isUnique = false;
        }
      });
      return isUnique;
    },
    loadExistingHouseholds() {
      householdsRef.on("value", (snap) => {
        let households = [],
          communityKey = this.communityKey;
        snap.forEach((household) => {
          if (communityKey == household.val().communityKey) {
            households.push(household);
          }
        });
        this.existingHouseholds = households;
      });
    },
  },
  mounted() {
    this.loadExistingHouseholds();
  },
};
</script>